module.exports = __webpack_public_path__ + "static/media/edit_wps_3.f4620987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/edit_wps_3.jpg
// module id = 1908
// module chunks = 0